export const COVERS = [
  { url: "https://images.pexels.com/photos/7087618/pexels-photo-7087618.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", label: "Mixing desk" },
  { url: "https://images.pexels.com/photos/8132531/pexels-photo-8132531.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", label: "Vocal booth" },
  { url: "https://images.pexels.com/photos/5749192/pexels-photo-5749192.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", label: "Producer suite" },
  { url: "https://images.pexels.com/photos/5650532/pexels-photo-5650532.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", label: "Rehearsal room" },
  { url: "https://images.pexels.com/photos/11044817/pexels-photo-11044817.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", label: "Live room" },
  { url: "https://images.unsplash.com/photo-1765539160785-e7953620488f?crop=entropy&cs=srgb&fm=jpg&q=85&w=940", label: "Neon studio" },
];

export const PLACEHOLDER = COVERS[0].url;

export function money(amount, currency = "EUR") {
  const n = Number(amount || 0);
  const symbol = currency === "GBP" ? "£" : currency === "USD" ? "$" : "€";
  return `${symbol}${n % 1 === 0 ? n : n.toFixed(2)}`;
}
